import { Component, Input, OnInit } from '@angular/core';

type EmptyStateVariant = 'page' | 'card';
type EmptyStateCardCopyAlignment = 'start' | 'center';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: false,
})
export class EmptyStateComponent implements OnInit {
  @Input() contextName: string;
  @Input() contextIcon: string;
  @Input() customContextName: string;
  @Input() customContextDescription: string;
  @Input() variant: EmptyStateVariant = 'page';
  @Input() cardCopyAlignment: EmptyStateCardCopyAlignment = 'start';

  title: string;
  description: string;
  cardStatusLabel: string = 'Unavailable';
  cardStatusVariant: 'limited' | 'empty' | 'neutral' = 'neutral';

  ngOnInit(): void {
    this.title = this.customContextName || `No ${this.contextName} yet`;
    this.description = this.customContextDescription || 'Once created, items will appear here';

    const isLimitedDataState = /not enough data/i.test(this.title);
    const isEmptyDataState = /^no\b/i.test(this.title);

    if (isLimitedDataState) {
      this.cardStatusLabel = 'Limited Data';
      this.cardStatusVariant = 'limited';
    } else if (isEmptyDataState) {
      this.cardStatusLabel = 'No Data';
      this.cardStatusVariant = 'empty';
    }
  }
}
